import http from "./http.service";


export const getAllSubServices = async (payload:any) => {
    return http.get(`/adminWeb/subservices`,{params:payload});
}
